import '../../../components/datetime/DayPicker.scss';
import '../../styles/DateTimeModal.scss';

import React, { PureComponent } from 'react';
import DayPicker from 'react-day-picker';
import moment, { Moment } from 'moment';
import { convertFieldFormatToMoment } from '../../../helpers/DateTimeUtility';
import Navbar from '../../../components/datetime/Navbar';
import YearMonthForm from '../../../components/datetime/YearMonthForm';
import GfModal from '../../../gfcomponents/GfModal/GfModal';

export interface DateModalProps {
  value?: string;
  fieldType?: number;
  dateTimeFormat?: string;
  onClose?: VoidFunction;
  onChanged?: (formatedDate: string, date: Moment) => void;
}

export default class DateModal extends PureComponent<DateModalProps, TypeMePlease> {
  constructor(props) {
    super(props);

    this.getDateFormat = this.getDateFormat.bind(this);
    this.pickerClose = this.pickerClose.bind(this);
    this.handleDayClicked = this.handleDayClicked.bind(this);
    this.handleDoneButtonClicked = this.handleDoneButtonClicked.bind(this);
    this.handleClearButtonClicked = this.handleClearButtonClicked.bind(this);
    this.handleYearMonthChange = this.handleYearMonthChange.bind(this);

    let currentDateTime = null;
    if (this.props.value) {
      currentDateTime = moment(this.props.value, this.getDateFormat());

      if (!currentDateTime.isValid()) {
        currentDateTime = moment(new Date());
      }
    } else {
      currentDateTime = moment(new Date());
    }

    this.state = {
      selectedDay: currentDateTime.toDate()
    };
  }

  getDateFormat() {
    return convertFieldFormatToMoment(this.props.dateTimeFormat);
  }

  pickerClose() {
    this.props.onClose();
  }

  handleDayClicked(day: Date) {
    this.setState({
      selectedDay: day
    });
  }

  handleDoneButtonClicked() {
    const dateTime = new Date(this.state.selectedDay);
    const dateValue = moment(dateTime).startOf('day');
    this.props.onChanged(dateValue.format(this.getDateFormat()), dateValue);
  }

  handleClearButtonClicked() {
    this.props.onChanged('', null);
  }

  handleYearMonthChange(month) {
    this.setState({ month });
  }

  render() {
    return (
      <GfModal
        title="Date"
        className="datetime-modal"
        primaryText="Done"
        secondaryText="Clear"
        onPrimaryClick={this.handleDoneButtonClicked}
        onSecondaryClick={this.handleClearButtonClicked}
        onClose={this.pickerClose}
        semanticUiModalProps={{ size: 'mini', closeOnDimmerClick: true }}
      >
        <DayPicker
          month={this.state.month}
          initialMonth={new Date(this.state.selectedDay)}
          selectedDays={[new Date(this.state.selectedDay)]}
          onDayClick={(day) => this.handleDayClicked(day)}
          navbarElement={({ nextMonth, previousMonth, onPreviousClick, onNextClick, className, localeUtils }) => (
            <Navbar
              nextMonth={nextMonth}
              previousMonth={previousMonth}
              onPreviousClick={onPreviousClick}
              onNextClick={onNextClick}
              className={className}
              localeUtils={localeUtils}
              onChange={this.handleYearMonthChange}
            />
          )}
          captionElement={({ date, localeUtils }) => <YearMonthForm date={date} localeUtils={localeUtils} onChange={this.handleYearMonthChange} />}
        />
      </GfModal>
    );
  }
}
